import i18n from 'src/i18n';
const configTable = () => {
    const tableColumns = [
        {
            prop: 'name',
            label: i18n.t('common_words.name'),
            align: 'center',
            sortable: true,
        },
        {
            prop: 'type',
            label: i18n.t('common_words.type'),
            align: 'center',
            sortable: true,
        }
    ];
    return { tableColumns };
}
export default configTable;